import gql from 'graphql-tag';

const NAME =
  'compositions_DealerLocator_DealerSearch_FeaturesFilter_dealerFeaturesQuery';

export default gql`
  query ${NAME} {
    dealerFeatures {
      code
      dealerFilter
      displayIcon
      id
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/withFeatureFilters/dealerFeaturesQuery.js